import { ReactComponent as MessagesIcon } from "../../../assets/icons/messages-solid.svg";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const IconMessages = (props: SvgIconProps) => (
  <SvgIcon
    component={MessagesIcon}
    inheritViewBox
    {...props}
    sx={{ ...props.sx, padding: "2px" }}
  />
);

export default IconMessages;
